/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-return-assign */
import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { computeActiveFilters } from 'shared-utils/src/helpersMyCasa';

import { Icon } from 'shared-vectors';
import FiltersIcon from 'shared-vectors/icons/Filters';

import { CtxContainer } from '@client/app/Container';
import { queryBuilder } from '@modals/factories';

import { isDrawonMapSearch } from '../../../helpers/search/Search';
import { isChildOf } from '../../../helpers/DOMHelpers';

import './critical.scss';
import SaveSearchButton from '../SaveSearchButton';
import SortComponent from './SortComponent';
import GoToMapButton from './GoToMapButton';

const propTypes = {
  mapUrl: PropTypes.string,
  mapLinkAvailable: PropTypes.bool,
  sortChange: PropTypes.func,
  sortType: PropTypes.string,
  sortValuesMap: PropTypes.instanceOf(Object),
  publisherName: PropTypes.string,
  setForcedAuction: PropTypes.func,
  checkProposeBkmAfterLead: PropTypes.func,
  userLogIn: PropTypes.func,
  viewport: PropTypes.instanceOf(Object),
};

const defaultProps = {
  mapUrl: '',
  mapLinkAvailable: false,
  sortChange: () => {},
  sortType: '',
  sortValuesMap: {},
  publisherName: null,
  setForcedAuction: () => {},
  checkProposeBkmAfterLead: () => {},
  userLogIn: () => {},
  viewport: {},
};

function TopButtons(props) {
  const context = useContext(CtxContainer);
  const sortWrapperRef = useRef(null);
  
  // State
  const [sortSelectIsOpen, setSortSelectIsOpen] = useState(false);
  const [sortValue, setSortValue] = useState(props.sortType);
  
  useEffect(() => {
    if (props.sortType !== sortValue) {
      setSortValue(props.sortType);
    }
  }, [props.sortType]);


  const closeSelectOnOutClick = (e) => {
    let node = null;
    if (sortSelectIsOpen) {
      node = sortWrapperRef.current;
    }
    if (!node) {
      return;
    }
    const { target } = e;
    if (!isChildOf(target, node)) {
      setSortSelectIsOpen(false);
      window.removeEventListener('click', closeSelectOnOutClick);
    }
  };

  const toggleSortSelect = () => {
    setSortSelectIsOpen(prevState => !prevState);
    setTimeout(() => {
      window.addEventListener('click', closeSelectOnOutClick);
    }, 0);
  };

  const handleSortChange = (val, dontTriggerToggle = false) => {
    setSortValue(val);
    props.sortChange(val);
    if (!dontTriggerToggle) {
      toggleSortSelect();
    }
  };

  const goToMap = () => {
    if (window.localStorage) {
      window.localStorage.setItem('_searchMapBackLinkURL', document.location);
      window.localStorage.removeItem('_map_lastActiveMarker');
    }
    document.location = props.mapUrl;
  };

  const openMobileSearch = () => {
    const {
      openModal,
      isMobile,
      isSmallMobile,
      filtersProps,
      pageType,
    } = context;

    console.log('**Action clicked: filtersHeader**');
    openModal &&
      openModal(
        queryBuilder({
          isMobile,
          isSmallMobile,
          filtersProps,
          panelChooseBy: {
            isMobile,
            actionClicked: 'filtersHeader',
            pageFrom: pageType,
          },
        }),
      );
  };

  const {
    sortValuesMap,
    mapLinkAvailable,
    publisherName,
    setForcedAuction,
    checkProposeBkmAfterLead,
    userLogIn,
    viewport,
  } = props;
  
  const {
    filtersProps: { filters, locations, isAgencySrp },
    model: { total, fewResults },
    constantsCopy: {
      SRP_SAVE_SEARCH_BTN_SAVE_SEARCH_MOBILE,
      SRP_EDIT_SEARCH_BTN_SAVE_SEARCH_MOBILE,
    },
  } = context;

  const showOnlyFiltersBtn =
    isAgencySrp || total === 0 || (fewResults && fewResults.page > 1);

  const showSaveSearchButton = !isAgencySrp;
  const { activeFiltersCount } = computeActiveFilters(filters);
  const activeFilters =
    activeFiltersCount > 0 ? <em>{activeFiltersCount}</em> : null;
  const btnsClass = 'srp-topbtns default-btn';

  return (
    <div className={btnsClass}>
      <button
        type="button"
        aria-label="Apri i filtri di ricerca"
        className="search default-btn"
        onClick={openMobileSearch}
      >
        <span className="icon-cont">
          <Icon name={FiltersIcon} width="24px" height="24px" fill />
        </span>
        <span className="text">
          <span className="mr--s">{'Filtri '}</span>
          {activeFilters}
        </span>
      </button>
      {(!showOnlyFiltersBtn || isDrawonMapSearch(locations, filters)) && (
        <GoToMapButton
          clsBtn="default-btn"
          goToMap={goToMap}
          mapLinkAvailable={mapLinkAvailable}
        />
      )}
      {(total > 0 || (fewResults && fewResults.page > 1)) && (
        <SortComponent
          viewport={viewport}
          setSortWrapper={(n) => {
            sortWrapperRef.current = n;
          }}
          sortSelectIsOpen={sortSelectIsOpen}
          showOnlyFiltersBtn={showOnlyFiltersBtn}
          sortValue={sortValue}
          sortValuesMap={sortValuesMap}
          toggleSortSelect={toggleSortSelect}
          sortChange={handleSortChange}
          isAgencySrp={isAgencySrp}
        />
      )}
      {showSaveSearchButton && (
        <SaveSearchButton
          publisherName={publisherName}
          setForcedAuction={setForcedAuction}
          checkProposeBkmAfterLead={checkProposeBkmAfterLead}
          userLogIn={userLogIn}
          notShownOn="desktop"
          positionGTM="SRP_PageTitle"
          copySaveSearch={{
            title: SRP_SAVE_SEARCH_BTN_SAVE_SEARCH_MOBILE,
            editTitle: SRP_EDIT_SEARCH_BTN_SAVE_SEARCH_MOBILE,
          }}
          showSaveSearchBannerGreenHint={false}
        />
      )}
    </div>
  );
}

TopButtons.propTypes = propTypes;
TopButtons.defaultProps = defaultProps;
export default TopButtons;
